import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    GET_FLAT_TRANSFER_PREVIEW,
    GET_FLAT_TRANSFER_PREVIEW_SUCCESS,
    GET_FLAT_TRANSFER_PREVIEW_FAILURE,
    EXECUTE_FLAT_TRANSFER,
    EXECUTE_FLAT_TRANSFER_SUCCESS,
    EXECUTE_FLAT_TRANSFER_FAILURE,
    GET_FLAT_TRANSFER_HISTORY,
    GET_FLAT_TRANSFER_HISTORY_SUCCESS,
    GET_FLAT_TRANSFER_HISTORY_FAILURE,
    GET_FLAT_TRANSFER_DETAIL,
    GET_FLAT_TRANSFER_DETAIL_SUCCESS,
    GET_FLAT_TRANSFER_DETAIL_FAILURE,
    REVERSE_FLAT_TRANSFER,
    REVERSE_FLAT_TRANSFER_SUCCESS,
    REVERSE_FLAT_TRANSFER_FAILURE,
    ADD_FLAT_TRANSFER_DOCUMENT,
    ADD_FLAT_TRANSFER_DOCUMENT_SUCCESS,
    ADD_FLAT_TRANSFER_DOCUMENT_FAILURE
} from '../../../actions/index.types';
import {
    getFlatTransferPreviewReq,
    executeFlatTransferReq,
    getFlatTransferHistoryReq,
    getFlatTransferDetailReq,
    reverseFlatTransferReq,
    addFlatTransferDocumentReq
} from '../../../../axios/request/SocietyPortal/FlatTransferReqs/FlatTransferReqs';

// Preview
function* getFlatTransferPreviewSaga(action) {
    try {
        const response = yield getFlatTransferPreviewReq(action);
        if (response.success === true) {
            yield put({ type: GET_FLAT_TRANSFER_PREVIEW_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_FLAT_TRANSFER_PREVIEW_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to load transfer preview");
        }
    } catch (error) {
        yield put({ type: GET_FLAT_TRANSFER_PREVIEW_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

// Execute
function* executeFlatTransferSaga(action) {
    try {
        const response = yield executeFlatTransferReq(action);
        if (response.success === true) {
            yield put({ type: EXECUTE_FLAT_TRANSFER_SUCCESS, data: response.data });
            toast.success(response.message || "Flat transfer posted successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: EXECUTE_FLAT_TRANSFER_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to execute flat transfer");
        }
    } catch (error) {
        yield put({ type: EXECUTE_FLAT_TRANSFER_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

// History
function* getFlatTransferHistorySaga(action) {
    try {
        const response = yield getFlatTransferHistoryReq(action);
        if (response.success === true) {
            yield put({ type: GET_FLAT_TRANSFER_HISTORY_SUCCESS, data: response });
        } else {
            yield put({ type: GET_FLAT_TRANSFER_HISTORY_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to fetch transfer history");
        }
    } catch (error) {
        yield put({ type: GET_FLAT_TRANSFER_HISTORY_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

// Detail
function* getFlatTransferDetailSaga(action) {
    try {
        const response = yield getFlatTransferDetailReq(action);
        if (response.success === true) {
            yield put({ type: GET_FLAT_TRANSFER_DETAIL_SUCCESS, data: response.data });
        } else {
            yield put({ type: GET_FLAT_TRANSFER_DETAIL_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to fetch transfer detail");
        }
    } catch (error) {
        yield put({ type: GET_FLAT_TRANSFER_DETAIL_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

// Reverse
function* reverseFlatTransferSaga(action) {
    try {
        const response = yield reverseFlatTransferReq(action);
        if (response.success === true) {
            yield put({ type: REVERSE_FLAT_TRANSFER_SUCCESS, data: response.data });
            toast.success(response.message || "Transfer reversed successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: REVERSE_FLAT_TRANSFER_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to reverse transfer");
        }
    } catch (error) {
        yield put({ type: REVERSE_FLAT_TRANSFER_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

// Add Document
function* addFlatTransferDocumentSaga(action) {
    try {
        const response = yield addFlatTransferDocumentReq(action);
        if (response.success === true) {
            yield put({ type: ADD_FLAT_TRANSFER_DOCUMENT_SUCCESS, data: response.data });
            toast.success(response.message || "Document attached");
            if (action?.data?.onSuccess) {
                action.data.onSuccess(response.data);
            }
        } else {
            yield put({ type: ADD_FLAT_TRANSFER_DOCUMENT_FAILURE, data: response.data });
            toast.error(response?.message || "Failed to attach document");
        }
    } catch (error) {
        yield put({ type: ADD_FLAT_TRANSFER_DOCUMENT_FAILURE, data: error });
        toast.error(error?.message || error?.response?.data?.message || "Something went wrong");
    }
}

export default function* FlatTransferSaga() {
    yield takeLatest(GET_FLAT_TRANSFER_PREVIEW, getFlatTransferPreviewSaga);
    yield takeLatest(EXECUTE_FLAT_TRANSFER, executeFlatTransferSaga);
    yield takeLatest(GET_FLAT_TRANSFER_HISTORY, getFlatTransferHistorySaga);
    yield takeLatest(GET_FLAT_TRANSFER_DETAIL, getFlatTransferDetailSaga);
    yield takeLatest(REVERSE_FLAT_TRANSFER, reverseFlatTransferSaga);
    yield takeLatest(ADD_FLAT_TRANSFER_DOCUMENT, addFlatTransferDocumentSaga);
}
